import { usePaymentMethods } from '@/api/usePaymentMethods'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useGenerateCompanyPath } from '@/libs'
import { Select, SelectProps } from '@dashboard/ui'
import { uniqueList } from '@/util'

interface SelectPMProps extends Omit<SelectProps, 'items'> {}

export const SelectPaymentMethod = (props: SelectPMProps) => {
  const { companyId, gameId } = useGenerateCompanyPath()
  const { t } = useTranslation()
  const { data: items = [] } = usePaymentMethods(companyId, gameId)

  const options = useMemo(() => {
    return uniqueList(
      items.filter(it => it.settings.enabled && it.settings.global_enabled && it.dashboard_show && it.logo_url),
      'meta_name',
    )
      .sort((a, b) => (a.caption || '').localeCompare(b.caption || ''))
      .map(it => ({
        value: it.meta_name,
        icon: () => <img src={it.logo_url} style={{ width: '32px', height: '32px' }} alt={it.caption} />,
        children: it.caption,
      }))
  }, [items])

  return (
    <Select
      {...props}
      items={options}
      placeholder={t('select-payment-method')}
      search={{
        placeholder: t('SearchInputPlaceHolder'),
        fn: (search, option) => {
          const s = search.toLowerCase().trim()
          const text = option.children as string
          const value = option.value + ''
          return text.toLowerCase().trim().includes(s) || value.toLowerCase().includes(s)
        },
      }}
    />
  )
}
